module.exports = __webpack_public_path__ + "static/media/affiliate.f93d9359.jpg";